import { useCallback, useEffect, useState } from "react";

import globals from "@/util/global-whitelist.mjs";

export type ScreenSize = { width: number; height: number };

function getScreenSize(): ScreenSize {
  if (!globals.document) return { width: 0, height: 0 };
  const element = (globals.document as Document).documentElement;

  return {
    width: element.clientWidth,
    height: element.clientHeight,
  };
}

export function useScreenSize(): ScreenSize {
  const [size, setSize] = useState<ScreenSize>(getScreenSize);

  const updateRect = useCallback(() => {
    const documentSize = getScreenSize();

    if (
      [Object.keys(documentSize) as unknown as keyof typeof documentSize].some(
        (key) => documentSize[key] !== size[key],
      )
    ) {
      setSize(documentSize);
    }
  }, [size, setSize]);

  useEffect(() => {
    const element = (globals.document as Document).defaultView;

    if (!element) return;

    element.addEventListener("resize", updateRect, { passive: true });

    return () => {
      element.removeEventListener("resize", updateRect);
    };
  }, []);

  return size;
}
